import React from 'react';
import './mobile-eval-list.styles.scss';
import { obfuscateString } from '../../../utils/obfuscation';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { Sources } from '@/forms/formTypes'

const MobileEvalList = ({
  evalList
}) => {

  return (
    <div className='mobile-eval-list'>
      {
        evalList && Object.keys(evalList).length > 0
        ?
        Object.values(evalList)
          .sort((a, b) => (a.ts < b.ts) ? 1 : -1)
          .map(ev => {
            const urlString = obfuscateString(JSON.stringify({ 'evalId': ev.evalId, 'cstKey': ev.userId }));
            if (!ev.platform) {
              ev.platform = 'eln';
            }
            return (
              <div 
                key={ev.ts}
                className='g-list-item'
                >
                <div className='title'>
                  {ev.title}
                </div>
                <div className="g-space-0-5"></div>
                <div className='meta'>
                  Type: {Sources?.[ev.source]?.title}
                </div>
                <div className='meta'>
                  Completed: {format(new Date(ev.ts), "Pp")}
                </div>
                <div className='meta'>
                  <td>{(ev.eventDate) ? `Event Date: ${format(new Date(ev.eventDate), "P")}` : ''}</td>
                </div>
                <div className='buttons'>
                  {
                    (ev.cpduUrl || ev.eoc)
                    ?
                    <Link
                      to={`/print/${urlString}`}
                      target="_blank">
                      <button className='g-button small-btn'>
                        Print Evidence
                      </button>
                    </Link>
                    // <Link to={ev.cpduUrl} target="_blank" rel="noopener noreferrer">
                    // 	Print
                    // </Link>
                    : ''
                  }
                </div>
              </div>
            )
          })
        :
        <p>No evaluations found.</p>
      }
    </div>
  )
}

export default MobileEvalList